<template>
  <v-expansion-panels flat accordion v-model="open">
    <display-expansion-panel>
      <display-expansion-panel-header class="font-weight-bold">
        {{ generateMessage('properties_360.titles.orders') }}
      </display-expansion-panel-header>
      <v-expansion-panel-content>
        <custom-simple-table
          :item="current"
          i18-path="properties_360.fields"
          :table-keys="[
            'operator_instructions',
            'reactive_instructions',
            'dispatcher_instructions',
          ]"
        />
      </v-expansion-panel-content>
    </display-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import { createNamespacedHelpers } from 'vuex';
import { generateMessage } from '@/utils/i18n';
import DisplayExpansionPanelHeader from '@/components/displays/panels/DisplayExpansionPanelHeader';
import DisplayExpansionPanel from '@/components/displays/panels/DisplayExpansionPanel';

const { mapGetters } = createNamespacedHelpers('properties_360');

export default {
  name: 'orders-accordion',
  components: {
    DisplayExpansionPanel,
    DisplayExpansionPanelHeader,
    CustomSimpleTable,
  },
  computed: {
    ...mapGetters(['current']),
  },
  methods: {
    generateMessage,
  },
  props: {
    beginOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      open: this.beginOpen ? 0 : null,
    };
  },
};
</script>
